
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { getOrderTime, getOrderTitle, getDisplayOrderNumber } from '@/utils/getters';
import Toast from '@/utils/toast';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import TableHeaders from '@/components/shared/suites/TableHeaders.vue';

@Component<CancelledOrderModal>({
	components: {
		StandardModal,
		TableHeaders
	}
})
export default class CancelledOrderModal extends Vue {
	@Action('fetchCancelledOrders', { namespace: 'orders' }) private fetchOrders!: () => Promise<Order[]>;

	private isLoading: boolean = false;
	private emptyTableText: string = this.$t('orders.management.cancelled_orders.no_cancelled_orders');
	private tableHeaders: TableHeader[] = [
		{ text: this.$t('orders.management.cancelled_orders.scheduled_for') },
		{ text: this.$t('orders.management.cancelled_orders.order_number') },
		{ text: this.$t('orders.management.cancelled_orders.details') }
	];
	private orders: Order[] = [];

	private async mounted(): Promise<void> {
		this.isLoading = true;
		try {
			this.orders = await this.fetchOrders();
		}
		catch (errorMessage) {
			Toast.error(this.$t('orders.management.error_fetching_orders', { errorMessage }));
			this.emptyTableText = this.$t('orders.management.cancelled_orders.error_fetching');
		}
		finally {
			this.isLoading = false;
		}
	}

	/**
	 * Get the scheduled time of the order depending of its type.
	 *
	 * @param {Order} order
	 * @return {string}
	 */
	private getOrderScheduledTime(order: Order): string {
		return getOrderTime(order);
	}

	/**
	 * Get the details of the order depending of its type.
	 *
	 * @param {Order} order
	 * @return {string}
	 */
	private getOrderDetails(order: Order): string {
		return getOrderTitle(order);
	}

	/**
	 * Get the order number to display, prefixed with the restaurant's internal identifier.
	 *
	 * @param {Order} order
	 * @return {string}
	 */
	private getOrderNumber(order: Order): string {
		return getDisplayOrderNumber(order.id, order.restaurant_id);
	}
}
